import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_USER_GALLERIES_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/user-galleries',
        iconClass: 'fas fa-photo-video',
        name: 'My Artcasts',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.AppUser_Galleries',
        order: 1
      },
    ]);
  };
}
